import React, { useState, useEffect, useContext } from "react";
import DataTable from "react-data-table-component";

import { AppContext } from "../../Context/Provider";
import { IoTrashOutline } from "react-icons/io5";
import { HiOutlinePencilSquare } from "react-icons/hi2";

function SupportDetailsFAQ() {
  const {
    CreateSupportDetailsFAQ,
    FetchSupportDetailsFAQ,
    SupportDetailFAQ,
    UpdateSupportDetailsFAQ,
    DeleteSupportDetailsFAQ,
    SupportOurservice,
    FetchSupportService,
    User,
  } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filtertext, setfiltertext] = useState("");
  const [Question, setQuestion] = useState("");
  const [Answer, setAnswer] = useState(""); // Corrected variable name
  const [error, setError] = useState("");
  const [currentId, setCurrentId] = useState(""); // Corrected spelling
  const [editMode, setEditMode] = useState(false); // New state to track edit mode
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [Count, setCount] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    FetchSupportDetailsFAQ();
    FetchSupportService();
  }, []);
  useEffect(() => {
    if (SupportOurservice && SupportOurservice.length > 0) {
      const optionsArr = SupportOurservice.map((item) => ({
        label: item.title,
        value: item._id,
      }));

      setOptions(optionsArr);
    }
  }, [SupportOurservice]);

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    console.log("change selected option", e.target.value);
  };
  const handleEdit = (row) => {
    console.log("Edit row: ", row);
    setQuestion(row.question);
    setCurrentId(row._id);
    setAnswer(row.answer);
    setCount(row.count);
    setSelectedOption(row.quesId);
    setShowModal(true);
    setEditMode(true); // Enable edit mode
  };
  const handleDelete = (rowId) => {
    setDeleteId(rowId); // Set the ID to delete
    setShowDeleteModal(true); // Show delete modal
  };

  const handleConfirmDelete = async () => {
    try {
      await DeleteSupportDetailsFAQ(deleteId);
      setDeleteId("");
      setShowDeleteModal(false);
    } catch (error) {
      console.error("Failed to delete the item:", error);
      // Optionally, show an error message to the user
    }
  };

  const columns = [
    { name: "Question", selector: (row) => row.question, grow: 1 },
    // { name: "Name", selector: (row) => row.name, grow: 1 },

    {
      name: "Answer",
      selector: (row) => row.answer,
      grow: 2,
      cell: (row) => <div style={{ whiteSpace: "normal" }}>{row.answer}</div>,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex space-x-2">
          <button
            onClick={() => handleEdit(row)}
            className="text-custom-green hover:text-blue-700"
          >
            <HiOutlinePencilSquare />
          </button>
          <button
            onClick={() => handleDelete(row._id)}
            className="text-custom-red hover:text-custom-yellow"
          >
            <IoTrashOutline />
          </button>
        </div>
      ),
      button: true,
      grow: 0.5,
    },
  ];
  const customStyles = {
    rows: {
      style: {
        minHeight: "72px", // override the row height
      },
    },
    headCells: {
      style: {
        paddingLeft: "8px", // override the cell padding for head cells
        paddingRight: "8px",
        backgroundColor: "#f8f9fa",
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        paddingLeft: "8px", // override the cell padding for data cells
        paddingRight: "8px",
      },
    },
  };
  const ClearData = () => {
    setQuestion("");
    setAnswer("");
    setError("");
    setCurrentId("");
    setSelectedOption("");
    setEditMode(false); // Reset edit mode
    setCount(""); // Reset edit mode
  };

  const filteredItems = SupportDetailFAQ?.filter((item) => {
    return columns.some((column) => {
      const value = column.selector ? column.selector(item) : null;
      return (
        value &&
        value.toString().toLowerCase().includes(filtertext.toLowerCase())
      );
    });
  });

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="flex flex-col items-end space-y-2 w-full p-4">
        <button
          onClick={() => {
            setShowModal(true);
            ClearData();
          }}
          className="px-4 py-2 bg-custom-green text-white rounded"
        >
          + Add
        </button>
        <input
          type="text"
          onChange={(e) => setfiltertext(e.target.value)}
          value={filtertext}
          placeholder="Search here"
          className="border rounded p-2 w-full max-w-xs"
        />
      </div>
    );
  }, [filtertext, resetPaginationToggle]);

  const handleTitleChange = (e) => {
    const inputValue = e.target.value;
    // Set maximum length for title
    const maxLength = 90; // Adjust this value as needed
    if (inputValue.length <= maxLength) {
      setQuestion(inputValue);
    } else {
      // Optionally show an error message or trim the input
      const truncatedValue = inputValue.slice(0, maxLength);
      setQuestion(truncatedValue);
    }
  };

  const handleDescriptionChange = (e) => {
    const inputValue = e.target.value;
    // Set maximum length for description
    const maxLength = 250; // Adjust this value as needed
    if (inputValue.length <= maxLength) {
      setAnswer(inputValue);
    } else {
      // Optionally show an error message or trim the input
      const truncatedValue = inputValue.slice(0, maxLength);
      setAnswer(truncatedValue);
    }
  };
  const handleAddOrUpdate = async () => {
    const data = {
      question: Question,
      answer: Answer,
      userId: User?.data?.id,
      quesId: selectedOption,
    };

    if (!Question || !Answer || !selectedOption) {
      setError("Please fill out all fields.");
      return;
    }
    setIsLoading(true);

    try {
      if (editMode) {
        await UpdateSupportDetailsFAQ(currentId, data);
      } else {
        // Otherwise, create new entry
        await CreateSupportDetailsFAQ(data);
      }
    } catch (err) {
      // Handle any potential errors from the API calls
      console.error(err);
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
      ClearData();
      setShowModal(false);
    }
  };

  return (
    <div className="px-8 py-2">
      {/* <h1 className="text-2xl font-semibold mb-4">Sercice</h1> */}

      <DataTable
        columns={columns}
        data={filteredItems}
        pagination
        paginationResetDefaultPage={resetPaginationToggle}
        subHeader
        subHeaderComponent={subHeaderComponentMemo}
        persistTableHead
        customStyles={customStyles}
      />

      {showModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-xl">
            <h2 className="text-xl font-bold mb-4  ">
              {editMode ? "Edit" : "Add"} Support Details FAQ
            </h2>
            <div className="grid grid-cols-12 gap-4 mb-4">
              <div className="col-span-12">
                <label
                  htmlFor="roles"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Select an option
                </label>
                <select
                  id="roles"
                  value={selectedOption}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value="" disabled>
                    Choose an option
                  </option>
                  {options.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-span-12">
                <label className="block text-gray-700 mb-2">Question</label>
                <input
                  type="text"
                  value={Question}
                  onChange={handleTitleChange}
                  className={`w-full p-2 border rounded ${
                    !Question && error ? "border-red-500" : ""
                  }`}
                  placeholder="Question"
                />
              </div>

              <div className="col-span-12">
                <label className="block text-gray-700 mb-2">Answer</label>
                <textarea
                  value={Answer}
                  onChange={handleDescriptionChange}
                  className={`w-full p-2 border rounded ${
                    !Answer && error ? "border-red-500" : ""
                  }`}
                  placeholder=" Answer .."
                  rows={4}
                />
              </div>
              {/* <div className="col-span-12">
                <label
                  className="block mb-2 text-sm font-medium text-gray-900"
                  htmlFor="file_input"
                >
                  {editMode ? "Change file (Optional)" : "Upload file"}
                </label>
                <input
                  className={`block w-full text-sm text-gray-900 border rounded-lg cursor-pointer bg-gray-50 focus:outline-none ${
                    !selectedFile && error ? "border-red-500" : ""
                  }`}
                  id="file_input"
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/svg+xml"
                  onChange={handleFileChange}
                />
               
              </div> */}
            </div>

            {/* <div className="flex justify-end space-x-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleAddOrUpdate}
                className="px-4 py-2 bg-green-500 text-white rounded"
              >
                {editMode ? "Update" : "Add"}
              </button>
            </div> */}
            <div className="flex justify-end space-x-2">
              <button
                onClick={() => {
                  setShowModal(false);
                  ClearData();
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
                disabled={isLoading}
              >
                Cancel
              </button>
              <button
                onClick={handleAddOrUpdate}
                className={`px-4 py-2 rounded ${
                  isLoading ? "bg-gray-400" : "bg-custom-green"
                } text-white`}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : editMode ? "Update" : "Create"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded shadow-lg w-full max-w-sm">
            <h2 className="text-xl font-bold mb-4 text-red-400 text-center">
              Are you sure?
            </h2>

            <p className="text-gray-700 mb-4">
              Are you sure you want to delete this record?
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={() => {
                  setShowDeleteModal(false);
                  setDeleteId("");
                }}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmDelete}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Yes,Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default SupportDetailsFAQ;
